import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=ee7fdc00&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports